import Footnotes from '@/utils/Footnotes';
import Transformer from '@/transformers/StockProductTransformer';

export const productOption = {
  uniqueSubscriptionId: 'usid-3',
  status: 'active',
  subscriptionStartDate: '03.05.2014',
  subscriptionEndDate: null,
  cancellationDate: null,
  earliestCancellationDate: '2018-11-13',
  minimumCommitmentPeriodFactor: 3,
  minimumCommitmentPeriodUnit: null,
  cancelAllowed: true,
  plannedCancelAllowed: false,
  reactivationAllowed: false,
  terminationAllowed: false,
  reservationTerminationAllowed: false,
  orderDeletionAllowed: false,
  resumeAllowed: false,
  productChangeAllowed: true,
  finalizeAllowed: false,
  finalizeEnabled: false,
  subscriptionBookedByExtern: false,
  administrationAllowed: false,
  subscriptionActivNotLocked: true,
  resetPromotionAndTrialStatusAllowed: true,
  subscriptionLocked: false,
  subscriptionDescriptions: [
    {
      name: 'Lizenzschlüssel',
      text: '34340983298173329834982',
      descriptionText: null,
      kind: 'html',
    },
  ],
  informationFields: [],
  promotionType: 0,
  optinPossible: false,
  optinAllowed: false,
  promotionEndDate: null,
  chargingIntervalList: [
    {
      intervalDurationStart: '01.11.2018',
      intervalDurationEnd: '30.11.2018',
      priceDisplay: '1,00 €',
      intervalState: 2,
    },
  ],
  nextRegularPayment: '15.12.2018',
  intervalUnit: 'months',
};

const footnotes = new Footnotes();
const response = {
  description: '',
  optionType: 'booked',
  subscriptionTemplateId: '12345678',
  productDescription: {
    texts: [
      {
        name: 'parameterNameMyProducts',
        text: 'Downloads: parameterNameMyProducts xyz',
        descriptionText: null,
        kind: null,
      },
      {
        name: 'productName',
        text: 'Sicherheitspaket Komplett S',
        descriptionText: null,
        kind: null,
      },
      {
        name: 'parameterValueMyProducts',
        text:
          '<a title="Norton 360 für PC" href="https://webdl.symantec.com/?SASSERVER=xsas.symantec.com&amp;TRANSID=%2f629236610%2fDw4FBm1GXSSS6YRUPWB2F0VX4CUJCTUpv0Wv%2f%2bWdxSZRR%3foverrideParameters%3d%2f%26%7e%2f%26%7e%2f34340983298173329834982%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%26LNG%3dDEU&amp;LNG=DEU&amp;USEDM=1&amp;BINARYTYPE=11" target="_blank">N360 für PC</a>  <a title="Norton AntiVirus für PC" href="https://webdl.symantec.com/?SASSERVER=xsas.symantec.com&amp;TRANSID=%2f629236610%2fDLEHha0FZ4YZVCU2QEZY1144P280AZT%2b%2b0%2f9%2f8JC58HJB%3foverrideParameters%3d%2f%26%7e%2f%26%7e%2f34340983298173329834982%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%26LNG%3dDEU&amp;LNG=DEU&amp;USEDM=1&amp;BINARYTYPE=11" target="_blank">NAV für PC</a>  <a title="Norton Internet Security für PC" href="https://webdl.symantec.com/?SASSERVER=xsas.symantec.com&amp;TRANSID=%2f629236610%2fDgf8KU0G8EXFS0II69MD51UDQ5VEAHnOBOPa%2fuKtb1GT0%3foverrideParameters%3d%2f%26%7e%2f%26%7e%2f34340983298173329834982%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%26LNG%3dDEU&amp;LNG=DEU&amp;USEDM=1&amp;BINARYTYPE=11" target="_blank">NIS für PC</a>  <a title="Norton Internet Security für MAC" href="https://webdl.symantec.com/?SASSERVER=xsas.symantec.com&amp;TRANSID=%2f629236610%2fCAjeVg27EBX20103GBHQQ1NNPCL2B6I8%2bon%2b%2fPzAtLZBL%3foverrideParameters%3d%2f%26%7e%2f34340983298173329834982%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%26LNG%3dDEU&amp;LNG=DEU&amp;USEDM=1&amp;BINARYTYPE=17" target="_blank">NIS für MAC</a>  <a title="Norton Mobile Security für Android und iOS" href="https://cloudconnect.norton.com/Download?skup=21321914&amp;partnerUnitId=1307&amp;pin=34340983298173329834982" target="_blank">NMS für Android und iOS</a>',
        descriptionText: null,
        kind: null,
      },
      {
        name: 'providerName',
        text: 'Telekom Deutschland GmbH',
        descriptionText: null,
        kind: null,
      },
      {
        name: 'headerSubTitleMyProducts',
        text: 'headerSubTitleMyProducts xyz',
        descriptionText: null,
        kind: null,
      },
      {
        name: 'headerTitleMyProducts',
        text: 'headerTitleMyProducts xyz',
        descriptionText: null,
        kind: null,
      },
      {
        name: 'orderReactivationSucceeded',
        text: 'orderReactivationSucceeded <strong>xyz</strong>',
        descriptionText: null,
        kind: null,
      },
      {
        name: 'orderCancellationSucceeded',
        text: 'orderCancellationSucceeded <strong>xyz</strong>',
        descriptionText: null,
        kind: null,
      },
      {
        name: 'orderTerminationSucceeded',
        text: 'orderTerminationSucceeded <strong>xyz</strong>',
        descriptionText: null,
        kind: null,
      },
      {
        name: 'hintMyProducts',
        text: 'hintMyProducts <strong>xyz</strong>',
        descriptionText: null,
        kind: null,
      },
      {
        name: 'productType',
        text: 'Lizenzpaket productType xyz',
        descriptionText: null,
        kind: null,
      },
      {
        name: 'orderReservationDeletionSucceeded',
        text: 'orderReservationDeletionSucceeded <strong>xyz</strong>',
        descriptionText: null,
        kind: null,
      },
    ],
    textLists: {},
    images: [
      {
        name: 'productLogoMyProducts',
        resourcePath: 'images/dummy_big.jpg',
        alt: 'Sicherheitspaket Komplett S Produkt Logo S',
        imageId: null,
      },
    ],
    hyperlinks: [],
    buttons: [],
    footnotes: [
      {
        name: 'footNoteMyProducts',
        text: 'footNoteMyProducts3 xyz123123123 123',
      },
      {
        name: 'footNoteMyProducts',
        text:
          'footNoteMyProducts2 asdasd asdsa sad asd asda sdsa dsad sad äööäöääöööäöä asdsa sad asd asda sdsa dasd asd asd asd sad asd sad sadasdljlsdkgjlasjfklsadjl ajdlkj lsajdl sajdl aksjd lasjdlsaj lsajdl kasjdlasjdl aksjdlaksjdsadlksajdlajslsajl saldjasldksajdlksajdlkpwodp adpko paskdpoaskdapsdk aspok apspsaodk aspo sapo sapd ksapo daskd psadk asp kapsodk sapod apsd pasod pasdk sapo sapodk sapd sapodk sap dpask dpasok dsapko dsapkdpsa kdsapdpksao sdapapspaskd pasodapsk pasokd pasodk apsodkpasdkapodkap wdapkd apwpodk apwkdpawd xyz',
      },
      {
        name: 'footNoteMyProducts',
        text: 'footNoteMyProducts1 <strong>xyz</strong>',
      },
    ],
  },
  productGroup: null,
  canNotSucceed: false,
  inputType: null,
  productAvailability: null,
  productOptions: [productOption],
};

export default Transformer.fetch(response, footnotes);
